import { Zoomer } from './zoomer.js';
import { RepeatWhileMouseDown, DragToScroll, Utils } from '../main/ObjectUtils.js';
import { HtmlAspectRatioSizer, HtmlSizerStrategy } from './HtmlDrawing/HtmlAspectRatioSizer.js';

export class ProductZoomer extends Zoomer {
  constructor() {
    const options = {
      AspectRatioSizerClass: HtmlAspectRatioSizer,
      RepeatWhileMouseDownClass: RepeatWhileMouseDown,
      DragToScrollClass: DragToScroll,
      UtilsClass: Utils,
      sizerStrategy: HtmlSizerStrategy.pctWidthPxHeight,
      zoomDelta: 1,
      zoomInterval: 20,
      isUsingTransitions: true,
      // The container of the zoomer element. The container is there to add margins, etc.
      targetContainer: document.querySelector('.zoomer-parent'),
      /* The element we are zooming. If we are dynamically creating the product drawing, then we
       * may not yet have an element to attach the zoom-target class to, and must manually call
       * Zoomer.assignTargetElement(...) later. */
      targetElement: document.querySelector('.zoomer .zoom-target'),
      zoomOutBtn: document.getElementById('zoom-out-btn'),
      zoomInBtn: document.getElementById('zoom-in-btn'),
      containBtn: document.getElementById('best-fit-btn'),
      pct100Btn: document.getElementById('pct-100-btn'),
      fullWidthBtn: document.getElementById('full-width-btn'),
      fullHeightBtn: document.getElementById('full-height-btn'),
      fullscreenBtn: document.getElementById('fullscreen-btn'),
      closeBtn: document.getElementById('close-btn'),
    };
    super(options);
  }

  // TODO: We probably don't need this static method. Just call the constructor directly.
  static install() {
    return new ProductZoomer();
  }
}